import { HTMLThemeElement } from '@archetype-themes/custom-elements/theme-element'
import { Slideshow } from '@archetype-themes/modules/slideshow'

class AnnouncementBar extends HTMLThemeElement {
  connectedCallback() {
    super.connectedCallback()
    this.section = this.closest('.shopify-section')
    this.sectionHeight = this.section.offsetHeight

    this._updateBarSize = () => {
      const rect = this.section.getBoundingClientRect()
      const visible = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0))
      const PageContainer = document.getElementById('PageContainer')
      PageContainer.style.setProperty('--announcement-bar-height', visible + 'px')

      const toolbarContent = this.closest('.toolbar__content')
      const announcementsItem = this.closest('.toolbar__item--announcements')
      if (toolbarContent && announcementsItem) {
        const availableWidth = toolbarContent.offsetWidth - announcementsItem.offsetWidth
        PageContainer.style.setProperty('--announcement-bar-width', availableWidth + 'px')
        toolbarContent.querySelector('.announcement-bar').style.visibility = 'visible'
      }
    }

    if (parseInt(this.dataset.blockCount) > 0) {
      this._updateBarSize()
      window.addEventListener('resize', this._updateBarSize, { passive: true })
      window.addEventListener('scroll', this._updateBarSize, { passive: true })
    }

    if (parseInt(this.dataset.blockCount) === 1) {
      return
    }

    const args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: document.documentElement.dir === 'rtl' ? 'right' : 'left',
      fade: true
    }

    this.flickity = new Slideshow(this, args)
    document.documentElement.style.setProperty('--announcement-bar-height', this.sectionHeight + 'px')
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy()
    }
    window.removeEventListener('resize', this._updateBarSize)
    window.removeEventListener('scroll', this._updateBarSize)
  }

  // Go to slide if selected in the editor
  onBlockSelect({ detail: { blockId } }) {
    const slide = this.querySelector('#AnnouncementSlide-' + blockId)
    const index = parseInt(slide.dataset.index)

    if (this.flickity && typeof this.flickity.pause === 'function') {
      this.flickity.goToSlide(index)
      this.flickity.pause()
    }
  }

  onBlockDeselect() {
    if (this.flickity && typeof this.flickity.play === 'function') {
      this.flickity.play()
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar)
